export enum ReportStatus {
    Queued = "Queued",
    Processing = "Processing",
    Completed = "Completed",
    Error = "Errored",
    InProgress="InProress"
  }